import { createContext, useContext } from 'react'
import { OptionChainOrderSides } from '../../../../util/optionChainOrders'

export type OptionChainHistoricalOrderMap = Record<string, Partial<OptionChainOrderSides>>

export const OptionChainOrderHighlightContext = createContext<OptionChainHistoricalOrderMap | null>(null)

export const useOptionChainHistoricalOrderMap = () => useContext(OptionChainOrderHighlightContext)
